import { selectAgencyCianId } from './selectAgencyCianId';
import { IState } from '../../../store';

export const selectAgencyUrl = (state: IState): string | null => {
  const agencyId = selectAgencyCianId(state);

  return agencyId ? `/company/${agencyId}` : null;
};
